export default __webpack_public_path__ + "static/media/home-delivery-disabled.c730f4e5.svg";